import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=496030cb&scoped=true&"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmModal.vue?vue&type=style&index=0&id=496030cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496030cb",
  null
  
)

export default component.exports